import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-relatorio-laudo-resumo',
  templateUrl: './relatorio-laudo-resumo.component.html',
  styleUrls: ['./relatorio-laudo-resumo.component.scss']
})
export class RelatorioLaudoResumoComponent implements OnInit {

  @Input() template;

  constructor() { }

  ngOnInit() {
  }

}
